<template>
    <div class="addr-mes">
        <ul class="addr-detail">
            <li v-for="(addr,index) in concact" class="clearfix">
                <h3>{{addr.name}}</h3>
                <div class="addrCont">
                    <i :style="{'background-image':'url('+ addr.addrUrl +')'}"></i><p>{{addr.addr}}</p>
                </div>
                <div class="addrCont">
                    <i :style="{'background-image':'url('+ addr.emailUrl +')'}"></i><p>{{addr.email}}</p>
                </div>
                <!--<div class="addrCont">-->
                    <!--<i :style="{'background-image':'url('+ addr.phoneUrl +')'}" ></i><p>{{addr.phone}}</p>-->
                <!--</div>-->
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                concact:[
                    {
                        name:'Beijing, China',
                        addr:'7F D-Block, Lei Shing Hong Center, No. 8 Guangshun South Street, Chaoyang District, Beijing',
                        email:'global@sensoro.com',
                        phone:'(+86) 010-8416-1077',
                        addrUrl:'/static/image/index/icons/address@2x.png',
                        emailUrl:'/static/image/index/icons/email@2x.png',
                        phoneUrl:'/static/image/index/icons/phone@2x.png'

                    },
                    {
                        name:'Shenzhen, China',
                        addr:'3506#, A, Tianxia International Center, Taoyuan Road, Nanshan District, Shenzhen',
                        email:'global@sensoro.com',
                        phone:'(+86) 400-686-3180',
                        addrUrl:'/static/image/index/icons/address@2x.png',
                        emailUrl:'/static/image/index/icons/email@2x.png',
                        phoneUrl:'/static/image/index/icons/phone@2x.png'
                    },
                    {
                        name:'Shanghai, China',
                        addr:'7th Floor, B, Kehai Building, Naxian Road, Pudong New District, Shanghai',
                        email:'applynow@kfstartups.com',
                        phone:'(+86) 400-686-3180',
                        addrUrl:'/static/image/index/icons/address@2x.png',
                        emailUrl:'/static/image/index/icons/email@2x.png',
                        phoneUrl:'/static/image/index/icons/phone@2x.png'
                    }
                ],
            }
        },
        methods: {},
        components: {},
        computed: {}
    }
</script>

<style lang="less">
    .addr-mes{
        padding: 0 140px;
        .addr-detail{
            display: flex;
            justify-content: space-between;
            li{
                width: 30%;
                h3{
                    font-size: 22px;
                    color: #252525;
                    line-height: 32px;
                    margin-bottom: 32px;
                    font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
                    font-weight: 500;
                }
                p{
                    /*float: left;*/
                    font-size: 16px;
                    color: #5D5D5D;
                    line-height: 26px;
                    margin-bottom: 8px;
                    margin-left: 8px;
                    width:360px;
                }
                i{
                    /*float: left;*/
                    width: 20px;
                    height:20px;
                    margin-top: 3px;
                    vertical-align: top;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position:center;
                }
                .addrCont{
                    display: flex;
                    /*align-items: center;*/
                    /*justify-items: center;*/
                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        .addr-mes {

            .addr-detail {

                li {
                    p {

                        width: 260px;
                    }
                    i{
                        height: 20px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/addr.vue